import * as React from "react";
import { Button, Tooltip } from "@fluentui/react-components";
import {
  bundleIcon,
  WeatherMoonFilled,
  WeatherMoonRegular,
  WeatherSunnyFilled,
  WeatherSunnyRegular,
} from "@fluentui/react-icons";

import { ThemeContext } from "../store/theme-context-api";
import { useIconButtonStyles } from "../styles/styles";

const LightThemeIcon = bundleIcon(WeatherSunnyFilled, WeatherSunnyRegular);
const DarkThemeIcon = bundleIcon(WeatherMoonFilled, WeatherMoonRegular);

export default function ThemeSwitcher() {
  const { isDarkTheme, changeTheme } = React.useContext(ThemeContext);
  const iconStyles = useIconButtonStyles();

  const onChange = (_event) => {
    changeTheme(!isDarkTheme);
  };

  return (
    <Tooltip content="Switch theme" relationship="label" withArrow>
      <Button
        className={iconStyles.dark}
        onClick={onChange}
        icon={isDarkTheme ? <LightThemeIcon /> : <DarkThemeIcon />}
        shape="circular"
        appearance="transparent"
      />
    </Tooltip>
  );
}
